export default {
  dps: {
    field: 'dps',
    display: 'DPS',
    description: 'Damage per Second',
    sort: 'desc',
    roles: ['dps', 'tank', 'healer'],
  },
  prioritydps: {
    field: 'prioritydps',
    display: 'PDPS',
    description: 'Damage per Second to Priority Target/Boss',
    sort: 'desc',
    roles: ['dps', 'tank', 'healer'],
  },
  raid_dps: {
    field: 'raid_dps',
    display: 'RDPS',
    description: 'Raid Damage per Second',
    sort: 'desc',
    roles: ['dps', 'tank', 'healer'],
  },
  hps: {
    field: 'hps',
    display: 'HPS',
    description: 'Healing per Second',
    sort: 'desc',
    roles: ['healer'],
  },
  raid_hps: {
    field: 'raid_hps',
    display: 'RHPS',
    description: 'Raid Healing per Second',
    sort: 'desc',
    roles: ['healer'],
  },
};
